<template>
  <div class="col-xl-6 mb-3 mb-xl-0" v-loading="loading">
    <div class="col-xl-12 col-lg-6">
      <card header-classes="bg-transparent">
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Boleto Gerados X Pagos
            </h6>
          </div>
        </div>
        <div class="card card-stats mb-4 mb-xl-0" show-footer-line="true">
          <bar-chart
            :height="350"
            ref="bigChart"
            :chart-data="bigBarChart.chartData"
            :extra-options="bigBarChart.extraOptions"
          ></bar-chart>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import * as chartConfigs from "@/components/Charts/config";
import BarChart from "@/components/Charts/BarChart";
import { DashboardFinancialService } from "@/services/customers/dashboard.financial.services";

export default {
  name: "GraphBilling",
  data() {
    return {
      loading: false,
      bigBarChart: {
        activeIndex: 0,
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    };
  },
  components: {
    BarChart,
  },
  methods: {
    initBigChart() {
      const vm = this;
      vm.loading = true;
      DashboardFinancialService.billet()
        .then((response) => {
          let barData = {
            datasets: response.values,
            labels: response.labels,
          };
          this.bigBarChart.chartData = barData;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
            duration: 5000,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    this.initBigChart();
  },
};
</script>
